"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const SvgComponent = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  viewBox: "0 0 24 24",
  fill: "none",
  role: "img"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M6.7 17.57a.6.6 0 00-.26.49v1.36c0 .46.48.73.85.5l2.32-1.45-1.66-1.72-1.24.82zm14.48-7.04l-1.96-1.25c0-.5-.08-1.11-.25-1.76-.4-1.52-1.1-2.64-1.6-2.5-.48.13-.56 1.47-.17 3l.08.25a8.11 8.11 0 00-.57-.66c-1.07-1.12-2.23-1.72-2.6-1.35-.35.38.23 1.58 1.3 2.7.44.45.9.82 1.3 1.07a2.22 2.22 0 00-.26 1.03c-1.8-1.33-5.37-3.75-7.78-3.75a4.4 4.4 0 00-3.64 1.95c-.06-.1-.1-.2-.18-.3a1.62 1.62 0 00-2.36 0 1.78 1.78 0 000 2.46 1.6 1.6 0 002.08.19l6.64 6.9c.21.21.5.34.79.34h5c.3 0 .56-.26.56-.58v-.58c0-.64-.5-1.15-1.11-1.15H13.1v-2c0-1.29-.83-2.43-2.01-2.78l-1.47-.44a.58.58 0 01-.39-.7c.09-.32.4-.49.69-.4l1.47.43a4.04 4.04 0 012.82 3.88v.85l2.22-1.15h3.6A2 2 0 0022 12.2a2.1 2.1 0 00-.82-1.66zm-1.96 1.4a.57.57 0 01-.55-.58c0-.32.25-.58.55-.58a.58.58 0 010 1.15z",
  fill: "currentColor"
}));
var _default = exports.default = SvgComponent;